import { DateTime } from 'luxon';

import { DEVICE_OS } from 'constants/values';

import { getDeviceOS, replaceSlashToDash } from 'helpers/utils';

const localDateFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};

export const getLocaleIdentifier = (country?: null | string) => {
    switch (country) {
        case 'US':
        case 'ZA':
        case 'KE':
        case 'CA':
        case 'GH':
            return 'en-US'; // mm-dd-yyyy

        case 'CN':
        case 'JP':
        case 'KR':
        case 'KP':
        case 'TW':
        case 'HU':
        case 'MN':
        case 'BT':
            return 'ja-JP'; // yyyy-mm-dd

        default:
            return 'ua-UA'; // dd-mm-yyyy
    }
};

export const getAndroidFormattedDate = (date: Date) => {
    const dd = date.getDate().toString();
    const mm = (date.getMonth() + 1).toString();
    const yyyy = date.getFullYear();

    return dd?.padStart(2, '0') + '-' + mm?.padStart(2, '0') + '-' + yyyy;
};

export const transformDateToISO = (date: string) => date?.replace(' ', 'T');

export const removeComma = (date: string) => date?.replace(/,(?![^,]*,)/m, ' ');

export const getLocaleDate = (date: string, timezone: string) =>
    DateTime.fromISO(date, { zone: timezone }).toLocal().toJSDate();

export const normalizeDateByLocale = ({
    date,
    country,
    timezone,
}: {
    date: string;
    country?: null | string;
    timezone?: string;
}) => {
    const localDate = getLocaleDate(transformDateToISO(date), timezone ?? 'UTC');

    const deviceOS = getDeviceOS();
    const localeIdentifier = getLocaleIdentifier(country);

    const isAndroid = deviceOS === DEVICE_OS.ANDROID && localeIdentifier === 'ua-UA';

    const localeDateString = isAndroid
        ? getAndroidFormattedDate(localDate)
        : localDate.toLocaleDateString(localeIdentifier, localDateFormatOptions);

    return replaceSlashToDash(removeComma(localeDateString));
};
